import { createReducer } from 'redux-act';
import { EMAIL_ENQUIRY_STATUS } from 'lib/enums/contactUs';
import { clearEnquiry, setEnquiry } from './enquiryActions';

const initialState = {
  error: null,
  enquiry: null,
  status: EMAIL_ENQUIRY_STATUS.READY,
};

export const reducer = createReducer(
  {
    [clearEnquiry]: (state) => ({
      ...state,
      error: null,
      enquiry: null,
      status: EMAIL_ENQUIRY_STATUS.READY,
    }),
    [setEnquiry]: (state, enquiry) => ({
      ...state,
      ...enquiry,
    }),
  },
  initialState,
);
